module.exports = __webpack_public_path__ + "img/nanore_token.gr.5360f15.png";